import {Ability} from '~/lib/ability';

export class UsersAbility extends Ability {
    canCreate = () => this.isAdmin();
    canEdit = () => this.isAdmin();
    canDelete = () => this.isAdmin();
}
